import React from "react";
import {
  ProviderName,
  PracticeName,
  EditButton,
  ActivePatientsLimit,
  RemainingCapacity
} from "../components";
import { DEFAULT_TABLE_COLUMNS, TABLE_COLUMNS_BY_SPECIALTY } from "../constants";
import * as tableColumnTypes from "../constants/tableColumnTypes";
import { translate } from "@td/shared_utils";
import { newPatientStatusLabel } from '../utils';

const getColumnProps = (columnType, handleModalOpen) => {
  switch (columnType) {
    case tableColumnTypes.PROVIDER:
      return {
        selector: ({ provider }) => (
          <ProviderName href={window.Routes.provider_path(provider.id)}>
            {provider.nameWithCredentials}
          </ProviderName>
        ),
        width: "minmax(min-content, auto)",
      };

    case tableColumnTypes.PROVIDER_PAYMENT_METHOD:
      return {
        selector: ({ provider }) => provider.paymentMethod,
        width: "minmax(min-content, auto)",
      };

    case tableColumnTypes.PRACTICE_LICENSES:
      return {
        selector: ({ practiceTeamParticipant }) => practiceTeamParticipant && (
          <PracticeName>
            {practiceTeamParticipant.practiceTeam.name}
            {practiceTeamParticipant.states.length > 0 && ` - ${practiceTeamParticipant.states.join(", ")}`}
          </PracticeName>
        ),
        width: "390px",
      };

    case tableColumnTypes.PROVIDER_LICENSES:
      return {
        selector: ({ practiceTeamParticipant }) => practiceTeamParticipant && (
          <PracticeName>
            {practiceTeamParticipant.states.length > 0 && practiceTeamParticipant.states.join(", ")}
          </PracticeName>
        ),
        width: "390px",
      };

    case tableColumnTypes.ACTIVE_PATIENTS_LIMIT:
      return {
        selector: ({ practiceTeamParticipant, provider }) => practiceTeamParticipant && practiceTeamParticipant.providerPanelExtension && (
          <ActivePatientsLimit
            practiceTeamParticipant={practiceTeamParticipant}
            provider={provider}
          />
        ),
        width: "minmax(min-content, auto)",
      };

    case tableColumnTypes.REMAINING_CAPACITY:
      return {
        selector: ({ practiceTeamParticipant }) => {
          return (
            <RemainingCapacity
              practiceTeamParticipant={practiceTeamParticipant}
            />
          )
        },
      };

    case tableColumnTypes.ACCEPT_NEW_PATIENTS:
      return {
        selector: ({ provider }) => provider && newPatientStatusLabel('provider_panel.list_view.new_patients', provider),
        width: "minmax(min-content, auto)",
      };
    case tableColumnTypes.ACTIONS:
      return {
        selector: (row) => (
          <EditButton
            onClick={handleModalOpen(row)}
          />
        ),
        width: "min-content",
      };
  }
};

const localizeColumnTitle = (name) => translate(null, "provider_panel.list_view.columns", name);

const getAllowedColumnsBySpecialty = (specialtyCode) => {
  return TABLE_COLUMNS_BY_SPECIALTY[specialtyCode] || DEFAULT_TABLE_COLUMNS;
};

export const mapColumnsBySpecialty = ({ specialtyCode, handleModalOpen }) => {
  const allowedColumns = getAllowedColumnsBySpecialty(specialtyCode);

  return allowedColumns.map((columnType) => {
    return {
      name: columnType,
      title: localizeColumnTitle(columnType),
      ...getColumnProps(columnType, handleModalOpen),
    };
  });
};
